(function () {
  if (window.__hpInit) return;
  window.__hpInit = true;

  document.addEventListener('click', function (e) {
    var faqQ = e.target.closest('[data-hp-faq-q]');
    if (faqQ) {
      var item = faqQ.closest('[data-hp-faq-item]');
      var group = faqQ.closest('[data-hp-faq]');
      var open = item.classList.contains('open');
      if (group) group.querySelectorAll('[data-hp-faq-item].open').forEach(function (i) { i.classList.remove('open'); });
      item.classList.toggle('open', !open);
      return;
    }

    var giftAmt = e.target.closest('[data-hp-gift-amt]');
    if (giftAmt) {
      var wrap = giftAmt.closest('.hp-gift__amounts');
      if (wrap) wrap.querySelectorAll('[data-hp-gift-amt]').forEach(function (b) { b.classList.toggle('on', b === giftAmt); });
      var card = giftAmt.closest('section').querySelector('[data-hp-gift-value]');
      if (card) card.textContent = giftAmt.getAttribute('data-price');
      var variantId = giftAmt.getAttribute('data-variant');
      if (variantId) {
        var cta = giftAmt.closest('section').querySelector('.hp-gift__cta a.hp-btn--primary');
        if (cta) {
          var url = cta.getAttribute('href').split('?')[0];
          cta.setAttribute('href', url + '?variant=' + variantId);
        }
      }
      return;
    }
  });

})();
